/* Future Form 2026 - interaction layer */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function initReveal(scope) {
    var nodes = (scope || document).querySelectorAll('[data-ff-reveal]:not(.ff-seen)');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in', 'ff-seen'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var group = el.parentElement && el.parentElement.hasAttribute('data-ff-stagger');
        if (group) {
          var sibs = Array.prototype.slice.call(el.parentElement.children);
          el.style.setProperty('--ff-delay', Math.min(sibs.indexOf(el), 8) * 80 + 'ms');
        }
        el.classList.add('is-in', 'ff-seen');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- header ---------- */
  function initHeader() {
    var hdr = document.querySelector('[data-ff-header]');
    if (!hdr) return;
    var last = window.pageYOffset;
    var ticking = false;
    function run() {
      var y = window.pageYOffset;
      hdr.classList.toggle('is-stuck', y > 8);
      if (hdr.hasAttribute('data-ff-autohide')) {
        if (y > last && y > 320) hdr.classList.add('is-hidden');
        else hdr.classList.remove('is-hidden');
      }
      last = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(run); ticking = true; }
    }, { passive: true });
    run();
  }

  /* ---------- mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-ff-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-ff-drawer-open]');
    var closers = drawer.querySelectorAll('[data-ff-drawer-close]');

    function open() {
      drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var f = drawer.querySelector('[data-ff-drawer-close]');
      if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    drawer.querySelectorAll('[data-ff-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.ff-drawer__row');
        if (!row) return;
        var isOpen = row.classList.contains('is-open');
        row.parentElement.querySelectorAll('.ff-drawer__row.is-open').forEach(function (r) {
          if (r !== row) { r.classList.remove('is-open'); var b = r.querySelector('[aria-expanded]'); if (b) b.setAttribute('aria-expanded', 'false'); }
        });
        row.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* ---------- accordions ---------- */
  function initAcc(scope) {
    (scope || document).querySelectorAll('[data-ff-acc] .ff-acc__h').forEach(function (btn) {
      if (btn.dataset.ffBound) return;
      btn.dataset.ffBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.ff-acc__i');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------- animated counters ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-ff-count]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = el.getAttribute('data-ff-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-ff-count')) || 0;
        var dec = (el.getAttribute('data-ff-count').split('.')[1] || '').length;
        var start = null;
        var dur = 1500;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 4);
          el.textContent = (target * eased).toFixed(dec);
          if (p < 1) window.requestAnimationFrame(step);
          else el.textContent = target.toFixed(dec);
        }
        window.requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { el.textContent = '0'; io.observe(el); });
  }

  /* ---------- horizontal rails ---------- */
  function initRails() {
    document.querySelectorAll('[data-ff-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-ff-rail-track]');
      if (!track) return;
      rail.querySelectorAll('[data-ff-rail-go]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-ff-rail-go') === 'prev' ? -1 : 1;
          var first = track.firstElementChild;
          var step = first ? first.getBoundingClientRect().width + 20 : 300;
          track.scrollBy({ left: dir * step * (window.innerWidth > 989 ? 2 : 1), behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- pdp gallery ---------- */
  function initGallery() {
    document.querySelectorAll('[data-ff-gallery]').forEach(function (gal) {
      var main = gal.querySelector('[data-ff-gallery-main]');
      if (!main) return;
      gal.querySelectorAll('[data-ff-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (!src) return;
          main.style.opacity = '0';
          window.setTimeout(function () {
            main.src = src;
            main.style.opacity = '1';
          }, 180);
          gal.querySelectorAll('[data-ff-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
      main.style.transition = 'opacity .25s ease';
    });
  }

  /* ---------- sticky buy bar ---------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-ff-stickybuy]');
    var anchor = document.querySelector('[data-ff-stickybuy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- hero intro ---------- */
  function initHero() {
    document.querySelectorAll('[data-ff-hero]').forEach(function (h) {
      window.requestAnimationFrame(function () { h.classList.add('is-in'); });
    });
  }

  function boot() {
    initReveal();
    initHeader();
    initDrawer();
    initAcc();
    initCounters();
    initRails();
    initGallery();
    initStickyBuy();
    initHero();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initAcc(e.target);
    initHeader();
    initDrawer();
    initRails();
    initGallery();
    initHero();
  });
})();
